import { Node, Mark, mergeAttributes } from "@tiptap/core";

export interface RecipeOptions {
  HTMLAttributes: Record<string, any>;
}

// Mark extension to preserve span elements with classes and data attributes
export const RecipeTagSpan = Mark.create({
  name: "recipeTagSpan",

  inclusive: false,

  parseHTML() {
    return [
      {
        tag: "span.tag.badge",
        getAttrs: (node) => {
          if (typeof node === "string") return false;
          const el = node as HTMLElement;
          const attrs: Record<string, any> = {};

          // Preserve all classes
          if (el.className) {
            attrs.class = el.className;
          }

          // Preserve data attributes
          Array.from(el.attributes).forEach((attr) => {
            if (attr.name.startsWith("data-")) {
              attrs[attr.name] = attr.value;
            }
          });

          return attrs;
        },
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ["span", mergeAttributes(HTMLAttributes), 0];
  },
});

// Extension to preserve recipe-tags div
export const RecipeTags = Node.create<RecipeOptions>({
  name: "recipeTags",

  group: "block",

  content: "inline*",

  parseHTML() {
    return [
      {
        tag: "div.recipe-tags",
        preserveWhitespace: "full",
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      "div",
      mergeAttributes({ class: "recipe-tags" }, this.options.HTMLAttributes, HTMLAttributes),
      0,
    ];
  },
});

// Mark extension for recipe meta spans
export const RecipeMetaSpan = Mark.create({
  name: "recipeMetaSpan",

  inclusive: false,

  parseHTML() {
    return [
      {
        tag: "span.prep-time, span.cook-time, span.servings",
        getAttrs: (node) => {
          if (typeof node === "string") return false;
          const el = node as HTMLElement;
          const attrs: Record<string, any> = {};

          if (el.className) {
            attrs.class = el.className;
          }

          Array.from(el.attributes).forEach((attr) => {
            if (attr.name.startsWith("data-")) {
              attrs[attr.name] = attr.value;
            }
          });

          return attrs;
        },
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ["span", mergeAttributes(HTMLAttributes), 0];
  },
});

// Extension to preserve recipe-meta div
export const RecipeMeta = Node.create<RecipeOptions>({
  name: "recipeMeta",

  group: "block",

  content: "inline*",

  parseHTML() {
    return [
      {
        tag: "div.recipe-meta",
        preserveWhitespace: "full",
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      "div",
      mergeAttributes({ class: "recipe-meta" }, this.options.HTMLAttributes, HTMLAttributes),
      0,
    ];
  },
});
